import { useEffect } from "react";
import usePagination from "./usePagination";
import { indexAssetsTypes } from "../api/its/assets_types";
import { IAssetType, IAssetTypeIndexParams } from "../models/AssetsTypes";

const useAssetsTypes = ({
    package_id,
    pageSize: defaultPageSize
}: IAssetTypeIndexParams): ReturnType<typeof usePagination<IAssetType>> => {

    const hookAssets = usePagination<IAssetType>({ pageSize: defaultPageSize });
    const { page, pageSize } = hookAssets;

    useEffect(() => {
        const getAssetsTypes = async () => {
            hookAssets.loadingStart();
            const { data, totalItems } = await indexAssetsTypes({
                package_id,
                table: 'assets_its'
            });
            hookAssets.setData(data);
            hookAssets.setTotalItems(totalItems)
            hookAssets.loadingEnd();
        }
        getAssetsTypes();
    }, [page, pageSize, package_id]);

    return hookAssets;
}

export default useAssetsTypes;